import React from 'react'
import { string, func, bool } from 'prop-types'
import {
  IconHome,
  IconBackNavigation,
  TouchableIcon,
  SpacerVertical,
  SpacerHorizontal,
  IconSearch
} from 'mage-deps/@klarna/bubble-ui'
import ButtonRoundPrimary from '@bubble-contrib/molecule-button-round-primary'
import ButtonRoundSecondary from '@bubble-contrib/molecule-button-round-secondary'
import { useEducationAnalytics, EducationFeature } from 'education-tools'
import { useHelpContext } from '../hooks'
import { hooks as i18nHooks } from 'mage-i18n'
import { palette } from '@bubble-ui/particle-colors'
import Greeting from '../Greeting'
import { SearchField } from 'mage-deps/@klarna/mp-ui'
import ShareButton from './ShareButton'

export default function ViewportHeader() {
  const t = i18nHooks.useTranslator()

  const { navigation, searchQuery, setSearchQuery, isSearching, setIsSearching } = useHelpContext()

  const trackBack = useEducationAnalytics({ category: 'uhqm/navigation/back', action: 'click' })
  const trackHome = useEducationAnalytics({ category: 'uhqm/navigation/home', action: 'click' })
  const trackSearch = useEducationAnalytics({ category: 'uhqm/navigation/search', action: 'click' })

  function onBackClick() {
    trackBack()
    navigation.pop()
  }

  function onHomeClick() {
    trackHome()
    navigation.reset()
  }

  function onSearchClick() {
    if (isSearching) {
      setSearchQuery('')
    }
    trackSearch()
    setIsSearching(!isSearching)
  }

  const homeHeaderStyle = {
    padding: 30,
    backgroundColor: palette.Opal
  }
  const pagesHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 20px',
    height: 60,
    backgroundColor: palette.Opal
  }
  const isHomePage = navigation.stacksize === 1

  return isHomePage ? (
    <header style={homeHeaderStyle}>
      <Greeting />
      <SpacerVertical medium />
      <SearchField
        id="uhqm-search-input"
        focused
        initialValue={searchQuery}
        searchCallback={setSearchQuery}
        label={t('hqm.search.input', {}, 'Search for articles ...')}
      />
    </header>
  ) : (
    <>
      <header style={pagesHeaderStyle}>
        <TouchableIcon
          Icon={IconBackNavigation}
          ariaLabel="Back"
          id="uhqm-back-button"
          onPress={onBackClick}
        />
        <div style={{ display: 'flex' }}>
          <RoundToggle
            testId="uhqm-search-button"
            label={t('hqm.search.buttonLabel', {}, 'Search')}
            Icon={IconSearch}
            onClick={onSearchClick}
            toggled={isSearching}
          />
          <SpacerHorizontal small />
          <ButtonRoundPrimary id="uhqm-home-button" size="medium" onPress={onHomeClick}>
            <IconHome />
          </ButtonRoundPrimary>
          <EducationFeature name="meg.help-tool.share-button">
            <ShareButton />
          </EducationFeature>
        </div>
      </header>
      {isSearching && (
        <div style={{ padding: '10px 20px' }}>
          <SearchField
            id="uhqm-search-input"
            focused
            initialValue={searchQuery}
            searchCallback={setSearchQuery}
            label={t('hqm.search.input', {}, 'Search for articles ...')}
          />
        </div>
      )}
    </>
  )
}

const RoundToggle = ({ testId, label, Icon, onClick, toggled = false }) => {
  return toggled ? (
    <ButtonRoundSecondary data-testid={testId} size="medium" ariaLabel={label} onPress={onClick}>
      <Icon />
    </ButtonRoundSecondary>
  ) : (
    <ButtonRoundPrimary data-testid={testId} size="medium" ariaLabel={label} onPress={onClick}>
      <Icon />
    </ButtonRoundPrimary>
  )
}

RoundToggle.propTypes = {
  testId: string.isRequired,
  label: string.isRequired,
  Icon: func.isRequired,
  onClick: func.isRequired,
  toggled: bool
}
